import React, { useState } from "react";

import { CaretRightFill, X } from "react-bootstrap-icons";
import { FilterValues, Helper } from "../../components/views";
import { Button } from "../../components/shared";
import styles from "./Menu.module.scss";

import { useDispatch, useSelector } from "react-redux";
import {
  answersSelector,
  distanceTypeSelector,
  graphSelector,
} from "../../store/selectors";
import { clearAnswers, searchGraph } from "../../store/actions";
import Select from "react-select";
import classNames from "classnames";

type SelectedNames = {
  value: string;
  label: string;
};

const Menu: React.FC = () => {
  const dispatch = useDispatch();
  const answers = useSelector(answersSelector);

  const [selectedNames, setSelectedNames] = useState<SelectedNames[]>([]);

  const pathInfo = answers?.map((answer) =>
    answer.path.reduce((pthinf, node, j) => {
      const arr = pthinf;
      if (arr.length) {
        arr.push(<CaretRightFill size={15} className={styles.arrow} />);
      }
      arr.push(
        <span className={styles.menu__alert__item} key={j}>
          &nbsp;&nbsp;{node.name}&nbsp;&nbsp;
        </span>
      );
      return arr;
    }, [] as React.ReactElement[])
  );

  const isSearchButtonDisabled =
    selectedNames.length === 0 || selectedNames.length === 1;

  const selectedDistanceType = useSelector(distanceTypeSelector);
  const graph = useSelector(graphSelector);
  const nodes = graph.nodeArray.map((item) => ({
    value: item.name,
    label: item.name,
  }));

  const handleReset = (): void => {
    setSelectedNames([]);
    dispatch(clearAnswers());
  };

  const handleSearch = (): void => {
    dispatch(
      searchGraph(
        graph,
        selectedNames?.map((item) => item.value),
        selectedDistanceType
      )
    );
  };

  return (
    <div className={styles.menu}>
      <div className={styles.menu__container}>
        <Select
          className={styles.menu__container__select}
          options={nodes}
          isMulti
          placeholder="Search nodes"
          isSearchable
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          onChange={setSelectedNames}
          value={selectedNames}
        ></Select>
        <FilterValues />
        <div className={styles.menu__buttons}>
          <Button
            disabled={isSearchButtonDisabled}
            className={classNames(styles.menu__buttons__search, {
              [styles.menu__buttons__search__disabled]: isSearchButtonDisabled,
            })}
            type="button"
            onClick={handleSearch}
          >
            Search
          </Button>
          <Button
            className={styles.menu__buttons__reset}
            type="button"
            onClick={handleReset}
          >
            Cancel
          </Button>
        </div>
        <div className={styles.menu__alert}>{pathInfo}</div>
        <Helper />
      </div>
    </div>
  );
};

export default Menu;
